import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import Header from '../../newFront/header/Header';
import { API_URL } from '../../Constants';

let apiUrl = API_URL;

function RequestManagement() {

    const [data, setData] = useState([])

    const handleViabilityRequest = (clientUuid, feasibilityUuid) => {
        localStorage.setItem('clientUuid', clientUuid);
        localStorage.setItem('feasibilityUuid', feasibilityUuid);
        window.location = '/viability-study';
    }

    const handleCreateCommerce = () => {
        window.location = '/create-commerce';
    }

    const handleApprovedCredits = () => {
        window.location = '/credits-to-review';
    }

    useEffect(() => {
        if (localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }

        fetch(apiUrl + '/v1/feasibility-inquiries?search=status:PENDING', {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setData(res.content);
                })
            } else {
                console.log("");
                alert("Usuario o Contraseña Incorrecto");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });
    }, [])

    return (
        <React.Fragment>
            <Header name={"admin"}/>
            <CssBaseline />

            <Container maxWidth="md">
                <br />
                <h1>Viabilidades pendientes de analizar</h1>
                <br />
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Comercio</TableCell>
                                <TableCell align="center">Nombre</TableCell>
                                <TableCell align="center">Documento</TableCell>
                                <TableCell align="center">Celular</TableCell>
                                <TableCell align="center"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row) => (
                                <TableRow
                                    key={row.client.uuid}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell align="center">{row.commerce.name}</TableCell>
                                    <TableCell align="center">{row.client.name} {row.client.lastName}</TableCell>
                                    <TableCell align="center">{row.client.documentType} - {row.client.documentNumber}</TableCell>
                                    <TableCell align="center">{row.client.cellphone}</TableCell>
                                    <TableCell align="center">
                                        <Button variant="contained" endIcon={<SendIcon />} onClick={() => handleViabilityRequest(row.client.uuid, row.uuid)}>
                                            Analizar
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <br />
                <Button variant="contained" endIcon={<SendIcon />} onClick={handleCreateCommerce}>
                    Crear Comercio
                </Button>
                <br/>
                <br/>
                <Button variant="contained" endIcon={<SendIcon />} onClick={handleApprovedCredits}>
                    Revisar documentos
                </Button>
                <br/>
            </Container>
        </React.Fragment>

    );
}

export default RequestManagement;